module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-48x48-a4a0e4b76286c5fdf6d9bf93a0033cd1.png";